const pageHeading1 = document.querySelector("h1");

if (pageHeading1 && pageHeading1.id === "animHeading") {
  const fragment = document.createDocumentFragment();

  pageHeading1.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const chars = node.nodeValue.replace(/&nbsp;/g, "\u00A0").split("");
      chars.forEach((char) => {
        const span = document.createElement("span");
        span.textContent = char;
        span.classList.add("animationOpacity");
        fragment.appendChild(span);
      });
    } else {
      fragment.appendChild(node.cloneNode(true));
    }
  });

  // Swap in-memory content into DOM
  pageHeading1.replaceChildren(fragment);

  // Remove .initAnimation class in batch
  document.querySelectorAll(".initAnimation").forEach((el) =>
    el.classList.remove("initAnimation")
  );

  const letters = pageHeading1.querySelectorAll("span");

  // Animate using requestAnimationFrame-like batching
  letters.forEach((char, i) => {
    setTimeout(() => {
      char.classList.remove("animationOpacity");
      if (i === letters.length - 1) {
        char.classList.add("underscore");
      }
    }, i * 65);
  });
} else if (pageHeading1) {
  pageHeading1.classList.add("underscore");
}
